import { Button, Grid, Stack, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const MedicalPlans = () => {
  const navigate = useNavigate()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="title2">Medical Plans</Typography>
      </Grid>
      <Grid item xs={12} lg={6}>
        <Button
          fullWidth
          variant="contained"
          color="anPurple"
          onClick={() => navigate('hospitals')}
        >
          Edit Hospitals
        </Button>
      </Grid>
      <Grid item xs={12} lg={6}>
        <Button
          fullWidth
          color="anPurple"
          variant="contained"
          onClick={() => navigate('templates')}
        >
          View EMP Templates
        </Button>
      </Grid>
    </Grid>
  )
}

export default MedicalPlans
